module.exports = __webpack_public_path__ + "img/check-circle.24c10a3b.svg";